import { useState } from 'react'

import { CopyToClipboard } from 'react-copy-to-clipboard'

import { Tooltip } from '@mui/material'

import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'

const ClickToCopy = ({ children, side="left" }) => {

  const [title, setTitle] = useState("Click to copy")

 return (side === "left") ? 
  
  (
    <CopyToClipboard text={children} onCopy={() => setTitle("copied")}>
      <Tooltip title={title} className='link'>
        <span>
          <ContentCopyOutlinedIcon className='mr-5' /> {children}
        </span>
      </Tooltip>
    </CopyToClipboard>
  )

  :
  
  (
    <CopyToClipboard text={children} onCopy={() => setTitle("copied")}>
      <Tooltip title={title} className='link'>
        <span>
          {children} <ContentCopyOutlinedIcon className='ml-5' />
        </span>
      </Tooltip>
    </CopyToClipboard>
  )

}

export default ClickToCopy